const baseChartSettings = {
	type: "line",
  height: 400,
  toolbar: { show: false },
};

const baseLegend = (isShow=true) => ({
  show: isShow,
});

const baseTheme = {
  mode: "light",
};

const baseDataLabels = {
  enabled: false,
};

const baseTooltip = (isShared=false) => ({
  shared: isShared,
  theme: 'dark',
  style: {
    fontSize: "12px",
    backgroundColor: "#000000",
  },
  x: {
    format: "dd/MM/yy HH:mm",
  },
});

const baseXAxis = (categories) => ({
  type: "text",
  range: undefined,
  categories,
  axisBorder: { show: false },
  axisTicks: { show: false },
  labels: {
    style: {
      colors: "#A3AED0",
      fontSize: "12px",
      fontWeight: "500",
    },
  },
});

const baseMarkers = {
  size: 6,
  hover: { sizeOffset: 3 },
};

const baseGrid = {
  show: false,
};

const baseYaxis = {
  show: true,
};

function getStrokeWidths(series, lineWidth = 4, barWidth = 0) {
  return series.map(s => s.type === 'line' ? lineWidth : barWidth);
}

export const createLineChartOptions = (categories) => ({
  chart: { ...baseChartSettings },
  legend: baseLegend(),
  theme: baseTheme,
  dataLabels: baseDataLabels,
  stroke: { curve: "straight" },
  tooltip: baseTooltip(),
  grid: baseGrid,
  xaxis: baseXAxis(categories),
  yaxis: baseYaxis,
  markers: baseMarkers,
});

export const createMixedChartOptions = (categories, series, stacked = true) => ({
  chart: { stacked, ...baseChartSettings },
  legend: baseLegend(),
  theme: baseTheme,
  dataLabels: baseDataLabels,
  stroke: {
    curve: "straight",
    width: getStrokeWidths(series),
  },
  tooltip: baseTooltip(),
  grid: baseGrid,
  xaxis: baseXAxis(categories),
  yaxis: baseYaxis,
  markers: baseMarkers,
});
